import { Box } from "@mui/material";
import { Alert } from "@platform/design-system";
import { JSX } from "react";

interface Props {
  title: string;
  message: string;
  severity?: "error" | "warning" | null;
  mt?: number;
  mb?: number;
}

const CustomAlert = ({
  title,
  message,
  severity,
  mt,
  mb,
}: Props): JSX.Element => (
  <Box mt={mt} mb={mb}>
    <Alert severity={severity ?? undefined} title={title}>
      {message}
    </Alert>
  </Box>
);

export default CustomAlert;
